import React from 'react';

import { gettext } from '@eventbrite/i18n';
import type { CalendarProps, FooterSignalProps } from '@eventbrite/timed-entry';
import type { DateAvailabilityStatus } from '../../../state/infiniteCalendarSeries';
import { DiscountSvg } from '../assests/DiscountSvg';
import { SoldOutIconSvg } from '../assests/SoldOutIconSvg';
import { COLORS } from '../colorConstants';
import styles from './CalendarContainer.module.scss';

export const calendarDateCellProps: CalendarProps<DateAvailabilityStatus>['dateCellProps'] =
    {
        available: {
            icon: null,
            enabled: true,
        },
        discount: {
            icon: <DiscountSvg />,
            enabled: true,
            className: styles.discountDateCell,
        },
        soldOut: {
            icon: <SoldOutIconSvg />,
            enabled: false,
            className: styles.soldOutDateCell,
        },
        highDemand: {
            enabled: true,
            icon: null,
            className: styles.highDemandDateCell,
        },
        unavailable: {
            enabled: false,
            icon: null,
            className: styles.unavailableDateCell,
        },
    };

export const footerSignals: Array<FooterSignalProps> = [
    {
        icon: <DiscountSvg />,
        backgroundColor: COLORS['yellow-300'],
        text: gettext('Discount').toString(),
    },
    {
        backgroundColor: COLORS['pink-300'],
        text: gettext('High demand').toString(),
    },
    {
        icon: <SoldOutIconSvg />,
        backgroundColor: COLORS['neutral-200'],
        text: gettext('Sold out').toString(),
    },
];
